import { UserListPicker } from '@backstage/plugin-catalog-react';
import { CatalogFilterBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { OrgSectionLabelProvider } from '../orgSectionLabel';

/**
 * Sobrescreve o filtro padrão `catalog-filter:catalog/list` para renomear a
 * seção da organization para "Componentes" (ver OrgSectionLabelProvider) e
 * iniciar em "Todos" — com a policy de grupos aplicada no backend, o "Todos"
 * já reflete apenas o que os grupos do usuário podem acessar.
 */
export const userListCatalogFilter = CatalogFilterBlueprint.make({
  name: 'list',
  params: {
    loader: async () => (
      <OrgSectionLabelProvider>
        <UserListPicker initialFilter="all" />
      </OrgSectionLabelProvider>
    ),
  },
});
